// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + ({"302":"reads","461":"skills","597":"projects","657":"project-card","962":"home"}[chunkId] || chunkId) + "-" + {"302":"6bb274c8d287e0524c6f","461":"4c7825ebf7f41cfa936d","597":"6a6c4334e846b535998d","657":"077d3235375ca26cacb9","771":"4dcb5c868971142c8f61","962":"cd52e074c29201587292"}[chunkId] + ".js";
};